<template>
  <div>
    <transition name="fade" mode="out-in">
      <div class="flex flex-col md:flex-row font-light leading-tight" :key="`facts-set-${paginationIndex}`">
        <div
          class="w-full md:w-1/2 p-2 text-center"
          :key="`fact-${i}`"
          v-for="(fact, i) in currentFacts">
          <p class="text-4xl xl:text-6xl text-blue-400"><up-counter :amount="fact.number" :prefix="fact.prefix" /></p>
          <p class="uppercase md:text-xl">{{ fact.name }}</p>
        </div>
      </div>
    </transition>

    <div class="mt-4 md:mt-8 text-center">
      <div
        class="rounded-full w-8 h-8 mr-2 mb-2 st-all cursor-pointer hover:bg-blue-300 inline-block"
        :class="(i - 1) == paginationIndex ? 'bg-blue-300' : 'bg-blue-400'"
        :key="`facts-page-${i}`"
        @click="setFacts(i - 1)"
        v-for="i in totalPages"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    facts: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      currentFacts: [],
      totalPages: 1,
      paginationIndex: 0,
    }
  },
  mounted() {
    this.totalPages = Math.ceil(this.facts.length / 2);
    this.setFacts(0);
  },
  methods: {
    setFacts(index) {
      this.currentFacts = [];
      
      let starts = index * 2;
      let ends = starts + 2;
      
      for (let i = starts; i < ends; i++) {
        if (typeof this.facts[i] != 'undefined') {
          this.currentFacts.push(this.facts[i]);
        }
      }

      this.paginationIndex = index;
    }
  }
}
</script>
